﻿(function (w, d, $) {
    $(d).ready(function () {
        $(".news.match-height").each(function () {
            $(this).find(".news-item").matchHeight({
                byRow: true
            });
        });
    });
})(window, document, jQuery);